import SequencesTable from "../../../../components/Admin/Processes/ETL-Sequence/SequenceTable/SequencesTable";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { ETLSequencesEndPointLogic } from "../../../../logic/Admin/ETLSequences/ETLSequencesEndPointLogic";
// import SimpleBackdrop from "../../../../components/BackDrop/BackDrop";
import { useSelector } from "react-redux";
import { selectUserData } from "../../../../features/userSlice";
import Page404 from "../../../../components/Page404/Page403";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import SequencesTableSkeleton from "../../../../components/Admin/Processes/ETL-Sequence/SequenceTable/SequencesTableSkeleton";

export default function ETLSequenceScreen(userToken: any) {
  const oauthTokenHeader = userToken?.userToken;
  const [isLoading, setIsLoading] = useState(true);
  const [reload, setReload] = useState(false);
  const [etlSequence, setEtlSequence] = useState([]) as any;
  const [processList, setProcessList] = useState([]) as any;
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedChain, setSelectedChain] = useState(null);
  const [selectedLastRunDate, setSelectedLastRunDate] = useState(null);
  const [selectedFrequencyDate, setSelectedFrequencyDate] = useState(null);
  const [status, setStatus] = useState(null);
  const dispatch = useDispatch();
  const response = useSelector(selectUserData);
  const hasEtlSequencesViewPermission = CheckPermissions(
    response?.data?.products?.admin,
    "processes",
    "view_etl_sequences"
  );

  const tableHeadings = {
    edit: "Edit",
    id: "Cron ID",
    name: "Queue Name",
    frequency: "Frequency",
    category: "Category",
    last_run: "Last Run",
    status: "Status",
    count: "Process Count",
    info: "More Info",
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const requests = [
          ETLSequencesEndPointLogic.getETLSequenceContent(
            oauthTokenHeader,
            setEtlSequence,
            dispatch
          ),
          ETLSequencesEndPointLogic.getETLProcessList(
            oauthTokenHeader,
            setProcessList,
            dispatch
          )
        ];
        await Promise.allSettled(requests);
      } catch (error) {
        console.error("Error fetching ETL Chains:", error);
      } finally {
        setIsLoading(false);
        setReload(false);
      }
    };
    if (oauthTokenHeader) {
      fetchData();
    }
    // eslint-disable-next-line
  }, [oauthTokenHeader, dispatch, reload === true]);

  return (
    <>
      {hasEtlSequencesViewPermission ? (
        <div style={{ background: "#ffffff" }}>
          {isLoading ? (
            <SequencesTableSkeleton />
          ) : (
            <SequencesTable
              etlSequence={etlSequence}
              setEtlSequence={setEtlSequence}
              processList={processList}
              isLoading={isLoading}
              selectedLastRunDate={selectedLastRunDate}
              setSelectedLastRunDate={setSelectedLastRunDate}
              selectedFrequencyDate={selectedFrequencyDate}
              setSelectedFrequencyDate={setSelectedFrequencyDate}
              oauthTokenHeader={oauthTokenHeader}
              tableHeadings={tableHeadings}
              selectedChain={selectedChain}
              setSelectedChain={setSelectedChain}
              selectedRow={selectedRow}
              setSelectedRow={setSelectedRow}
              setStatus={setStatus}
              status={status}
              setReload={setReload}
            />
          )}
        </div>
      ) : (
        <Page404 />
      )}
    </>
  );
}
